/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import { useState } from "react";
import axios from "axios";
import {apiUrl} from "../constants/URL";
import ErrorAlert from "../components/PantallesBKI/Alertas/ErrorAlert";
import { useRequeriment } from "./useRequeriment";

const useDocumentacio = () => {

  const [data] = useState([]);
  const url = apiUrl() + "/requeriment/documentacio";
  const { postDades } = useRequeriment();

  const uploadFiles = async (files) => {

    // Obtener datos del localStorage
    const dadesRequerimentString = localStorage.getItem('dadesRequeriment');
    const dadesRequeriment = JSON.parse(dadesRequerimentString);

    // Construimos el FormData para los archivos
    const formData = new FormData();
    files.forEach((file) => formData.append("file", file));

    // Agregamos los datos al FormData como parte del cuerpo del formulario
    formData.append("data", JSON.stringify({
      nif: dadesRequeriment.nif,
      numActuacio: dadesRequeriment.numActuacio,
      numRegistreSortida: dadesRequeriment.numRegistreSortida,
    }));
    try {
    // Solicitud asincrónica
    const dades = await axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })

    if (dades.status === 200) {
      try {
        // Realizamos la petición para obtener los datos actualizados
        await postDades({
          nif: dadesRequeriment.nif,
      numActuacio: dadesRequeriment.numActuacio,
      numRegistreSortida: dadesRequeriment.numRegistreSortida,
        });

        window.location.reload();
      } catch (error) {
        ErrorAlert(
          "Error en el procés de càrrega de documents. "+ error.message,
          10000
        );
      }

    }
    else{
      ErrorAlert(
        "Error en el procés de càrrega de documents.",
        10000
      );
    }

  } catch (error) {
    ErrorAlert(
      "Error en el procés de càrrega de documents.",
      10000
    );

  }
  };



  return { uploadFiles, data };
};

export default useDocumentacio;
